import type { ComponentProps } from 'react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type IconButtonProps = ComponentProps<typeof Button> & {
  label: string;
};

export const IconButton = (props: IconButtonProps) => {
  const {
    label,
    variant = 'ghost',
    size = 'icon-sm',
    children,
    ...buttonProps
  } = props;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={variant}
          size={size}
          aria-label={label}
          {...buttonProps}
        >
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
